"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var OverflowDetector_1 = __importDefault(require("./OverflowDetector"));
var SearchResultBarItem_1 = __importDefault(require("./SearchResultBarItem"));
var ui_1 = require("@aperza/ui");
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var SearchResultBarContent = /** @class */ (function (_super) {
    __extends(SearchResultBarContent, _super);
    function SearchResultBarContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResultBarContent.prototype.handleOverflowChange = function (isOverflowed) {
        if (this.props.onOverflowChange) {
            this.props.onOverflowChange(isOverflowed);
        }
    };
    SearchResultBarContent.prototype.render = function () {
        var viewer = this.props.viewer;
        var searchModel = viewer && viewer.searchModel ? viewer.searchModel : {};
        var searchItem = viewer && viewer.searchItem ? viewer.searchItem : {};
        var searchCatalog = viewer && viewer.searchCatalog ? viewer.searchCatalog : {};
        var searchNews = viewer && viewer.searchNews ? viewer.searchNews : {};
        var keyword = util_1.AppConfigService.getSearchKeyword();
        var searchModelCount = searchModel.count;
        var searchItemCount = searchItem.count;
        var searchCatalogCount = searchCatalog.count;
        var searchNewsCount = searchNews.count;
        var params = util_1.AppConfigService.getSearchParams();
        var paramKeyCount = 0;
        Object.keys(params).forEach(function (key) {
            if (['fb', 'fc', 'fs', 'fo'].indexOf(key) != -1) {
                paramKeyCount++;
            }
        });
        if (params.fop && params.fop == 'true') {
            paramKeyCount++;
        }
        //Disable for now https://aperza.atlassian.net/browse/AB-5810
        //TODO to remove this section completely
        // if (AppConfigService.isSearchModel() && paramKeyCount > 0) {
        //   searchModelCount = '-';
        // } else if (AppConfigService.isSearchItem() && paramKeyCount > 0) {
        //   searchItemCount = '-';
        // } else if (AppConfigService.isSearchCatalog() && paramKeyCount > 0) {
        //   searchCatalogCount = '-';
        // } else if (AppConfigService.isSearchNews() && paramKeyCount > 0) {
        //   searchNewsCount = '-';
        // }
        var style = {
            justifyContent: 'space-between',
            overflowX: 'auto',
        };
        if (this.props.margin) {
            style.margin = this.props.margin;
        }
        return (react_1.default.createElement(OverflowDetector_1.default, { onOverflowChange: this.handleOverflowChange.bind(this), className: "strip", style: style },
            react_1.default.createElement("div", { className: "strip" },
                react_1.default.createElement(SearchResultBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "searchResultBar.model" }), count: searchModelCount, selected: util_1.AppConfigService.isSearchModel(), url: "https://www" + appConfig.baseComDomain + "/" + appConfig.langCode + "/s/model/?k=" + encodeURIComponent(keyword) + "&rf=1109" }),
                react_1.default.createElement(SearchResultBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "searchResultBar.catalog" }), count: searchCatalogCount, selected: util_1.AppConfigService.isSearchCatalog(), url: "https://www" + appConfig.baseComDomain + "/" + appConfig.langCode + "/s/catalog/?k=" + encodeURIComponent(keyword) + "&rf=1110" }),
                react_1.default.createElement(SearchResultBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "searchResultBar.item" }), count: searchItemCount, selected: util_1.AppConfigService.isSearchItem(), url: "https://ec" + appConfig.baseComDomain + "/" + appConfig.langCode + "/s/item/?k=" + encodeURIComponent(keyword) + "&rf=1112" }),
                react_1.default.createElement(SearchResultBarItem_1.default, { title: react_1.default.createElement(ui_1.Message, { messageId: "searchResultBar.news" }), count: searchNewsCount, selected: util_1.AppConfigService.isSearchNews(), url: "https://www" + appConfig.baseDomain + "/" + appConfig.langCode + "/s/news/?k=" + encodeURIComponent(keyword) + "&rf=1113" }))));
    };
    SearchResultBarContent.propTypes = {
        viewer: prop_types_1.default.shape({
            searchModel: prop_types_1.default.shape({
                count: prop_types_1.default.number,
            }),
            searchItem: prop_types_1.default.shape({
                count: prop_types_1.default.number,
            }),
            searchCatalog: prop_types_1.default.shape({
                count: prop_types_1.default.number,
            }),
        }),
        margin: prop_types_1.default.string,
        onOverflowChange: prop_types_1.default.func,
    };
    return SearchResultBarContent;
}(react_1.default.Component));
exports.default = SearchResultBarContent;
// export default createFragmentContainer(SearchResultBarContent, {
//   viewer: graphql`
//     fragment SearchResultBarContent_viewer on Viewer
//       @argumentDefinitions(params: { type: "String" }) {
//       searchModel(params: $params) {
//         count
//       }
//       searchItem(params: $params) {
//         count
//       }
//       searchCatalog(params: $params) {
//         count
//       }
//       searchNews(params: $params) {
//         count
//       }
//     }
//   `,
// });
